import { makeStyles } from 'tss-react/mui';

export const rootStyle = makeStyles()((theme) => ({
  hideLastPage: {
    '&>ul>li:nth-last-of-type(2)': { display: 'none' },
  },
  root: {
    padding: '6px 8px',
    display: 'flex',
    justifyContent: 'center',
    '&>.MuiPagination-root': {
      display: 'inline-flex',
    },
    // Base styling for each pagination item. Previously injected globally via the
    // legacy @mui/styles `makeStyles(..., { name: "MuiPaginationItem" })` trick,
    // which tss-react does not replicate — scope it to this component instead.
    '& .MuiPaginationItem-root': {
      color: '#696781',
      fontWeight: 600,
      fontFamily: 'AvenirNext',
      fontStretch: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      margin: '0 5px',
    },
  },
  goTo: {
    display: 'inline-flex',
    alignItems: 'center',
    marginLeft: '50px',
    fontFamily: 'AvenirNext',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 12,
    '&>.MuiButton-root': {
      fontSize: 12,
      fontWeight: 600,
      fontFamily: 'AvenirNext',
      fontStretch: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      textTransform: 'none',
      color: '#696781',
      minWidth: 'unset',
      padding: '0px',
      marginLeft: '9px',
    },
    '&>.MuiButton-endIcon': {
      marginRight: '0px !important',
      marginLeft: '-3px',
      marginTop: '2px',
    },
  },
  text: {
    color: '#cdccdf',
  },
  input: {
    width: '100px',
    height: '20px',
    borderRadius: '3px',
    border: 'solid 1px #cdccdf',
    backgroundColor: '#ffffff',
    boxSizing: 'border-box',
    marginLeft: '5px',
    color: '#696781',
    '&::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
    },
  },
  rightIcon: {
    color: '#696781',
  },
  customPagination: {
    '& .MuiPaginationItem-root.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
  greenPagination: {
    '& .MuiPaginationItem-root.Mui-selected': {
      backgroundColor: '#2f6f44',
      color: 'white',
      '&:hover': {
        backgroundColor: '#2f6f44',
      },
    },
  },
}));
